import React from 'react';
import { translate } from 'react-i18next';

import ShiftDetailBlock from 'components/ScheduleSidebar/ShiftDetailBlock.js';
import SidebarShiftOffer from 'components/ScheduleSidebar/SidebarShiftOffer.js';
import EmployeeActions from 'actions/EmployeeActions.js';

class SidebarExchangeOffer extends React.Component {
  constructor(props) {
    super(props);

    this.onSubmitBids = this.onSubmitBids.bind(this);
    this.onCancelBids = this.onCancelBids.bind(this);

    this.selectedShifts = [];
  }

  componentDidMount() {
    BidsStore.on('exchanges:post:bids:success', this._onSuccessfulBids, this);
  }

  _onSuccessfulBids(collection, response) {
    if (!this.props.shiftData) return;
    collection.last().set({ shift_id: this.props.shiftData.shift_id });
    const newBidID = collection.last().present().id;
    this.props.shiftData.bids.push(newBidID);
  }

  componentWillUnmount() {
    BidsStore.off('exchanges:post:bids:success', this._onSuccessfulBids, this);
    this.selectedShifts = [];
  }

  onSubmitBids(e) {
    const bids = [];
    const len = this.props.selectedExchangeDays.length;
    for (let i = 0; i < len; i++) {
      const shift_id = this.props.selectedExchangeDays[i].data.id;
      bids.push(shift_id);
    }

    if (EmployeeActions && bids.length > 0) {
      EmployeeActions.submitExchangeBid(bids, this.props.shiftData.id);
    }

    e.stopPropagation();
  }

  onCancelBids(e) {
    if (EmployeeActions) {
      const exchange = ExchangesStore.getExchangeByShiftId(this.props.shiftData.shift_id);
      if (!Utils.isNotDefined(exchange)) {
        EmployeeActions.cancelExchangeOffer(exchange.id);
      }
    }
    e.stopPropagation();
  }

  _onRemoveShiftSelection(shift) {
    this.props.removeSelectedDay([shift]);
  }

  hasUserName(userName)
  {
    if (Utils.isNotDefined(userName))
      return false;

    return (typeof userName == 'object' && userName.hasOwnProperty('name') );
  }

  render() {
    let startTime = '';
    let endTime = '';
    if (this.props.active && this.props.shiftData && !Utils.isNotDefined(this.props.shiftData)) {
      startTime = moment(this.props.shiftData.shift_details.start_time)
        .tz(this.props.shiftData.shift_details.time_zone)
        .format('h:mm a');
      endTime = moment(this.props.shiftData.shift_details.end_time)
        .tz(this.props.shiftData.shift_details.time_zone)
        .format('h:mm a');
      var userName = ExchangesStore.getExchangeUser(this.props.shiftData.user_id);
      var hideEnd = this.props.shiftData.shift_details.hide_end_time;
      var breaks = null;
      var shift_notes = null;
      var exchange_notes = null;

      if (!Utils.isNotDefined(this.props.shiftData.shift_details)) {
        if (!Utils.isNotDefined(this.props.shiftData.shift_details.breaks)) {
          breaks = Utils.formatUnformattedBreaks(this.props.shiftData.shift_details.breaks);
        }

        if (!Utils.isNotDefined(this.props.shiftData.shift_details.shift_notes)) {
          shift_notes = this.props.shiftData.shift_details.shift_notes;
        }
      }

      if (!Utils.isNotDefined(this.props.shiftData.notes)) {
        exchange_notes = this.props.shiftData.notes;
      }
    }

    this.selectedShifts = [];
    let disabled = 'disabled';
    let bids = this.props.selectedExchangeDays;
    let len = bids ? bids.length : 0;
    let accepted = false;
    let acceptedUserName = undefined;

    if (len > 0) disabled = '';
    if (len == 0 && !Utils.isNotDefined(this.props.shiftData)) {
      var exchange = ExchangesStore.getExchangeByShiftId(this.props.shiftData.shift_id);
      if (
        !Utils.isNotDefined(exchange)
        && Utils.isNotDefined(exchange.accepted_shift_id)
        && Utils.isNotDefined(exchange.accepted_user_id)
      ) {
        bids = BidsStore.getBidsByExchangeID(exchange.id);
      } else if (
        !Utils.isNotDefined(exchange)
        && !Utils.isNotDefined(exchange.accepted_shift_id)
        && !Utils.isNotDefined(exchange.accepted_user_id)
        && (exchange.accepted_user_id === Utils.getCoreUser().id
          || exchange.user_id === Utils.getCoreUser().id)
      ) {
        // shift was accepted, there are no bids in the data anymore, so show the selected shift.
        var acceptedShift = ShiftStore.getAllShiftsByShiftId(exchange.accepted_shift_id);
        if (Utils.isNotDefined(acceptedShift)) {
          acceptedShift = ExchangesStore.getExchangeShiftDetailsByShiftId(
            exchange.accepted_shift_id,
          );
        }
        if (!_.isUndefined(acceptedShift)) {
          bids = [acceptedShift];
          acceptedUserName = ExchangesStore.getExchangeUser(exchange.accepted_user_id);
          accepted = true;
        }
      }
      len = !Utils.isNotDefined(bids) ? bids.length : 0;
    }
    for (let i = 0; i < len; i++) {
      if (!Utils.isNotDefined(this.props.shiftData)) {
        const bid = !Utils.isNotDefined(bids[i].data) ? bids[i].data : bids[i];
        const deets = !Utils.isNotDefined(bid.shift_details) ? bid.shift_details : bid;
        const overlap = !Utils.isNotDefined(bids[i].overlap) ? bids[i].overlap : false;
        this.selectedShifts.push(
          <SidebarShiftOffer
            key={_.uniqueId()}
            exchangeDaySelectMode={this.props.exchangeDaySelectMode}
            shiftData={deets}
            selectedDate={moment(deets.start_time).tz(deets.time_zone)}
            active="true"
            accepted={accepted}
            shiftID={deets.shift_id}
            onRemoveShiftSelection={this._onRemoveShiftSelection.bind(this)}
            overlappedShift={overlap}
            userName={this.hasUserName(acceptedUserName) ? acceptedUserName.name : undefined }
          />,
        );
      }
      disabled = '';
    }

    const classes = `calendar-input exchange-offer ${!this.props.active ? 'hide' : ''}`;
    const buttonClasses = `calendar-input full-flex-container exchange-buttons ${
      !this.props.active ? '' : ''
    }`;

    let offerButtonClasses = 'calendar-input-button send-shift-offer';
    if (
      (this.props.active
        && !Utils.isNotDefined(this.props.shiftData)
        && BidsStore.iHazBidz(this.props.shiftData))
      || (!Utils.isNotDefined(this.props.shiftData) && this.props.shiftData.state == 'accepted')
    ) {
      offerButtonClasses += ' hide';
    }

    let cancelButtonClasses = 'calendar-input-button cancel-shift-offer';
    if (
      this.props.active
      && !Utils.isNotDefined(this.props.shiftData)
      && !BidsStore.iHazBidz(this.props.shiftData)
    ) {
      cancelButtonClasses += ' hide';
    } else if (
      this.props.active
      && !Utils.isNotDefined(this.props.shiftData)
      && BidsStore.iHazBidz(this.props.shiftData)
      && this.props.shiftData.state == 'accepted'
    ) {
      cancelButtonClasses += ' hide';
    }

    let pendingButtonClasses = 'calendar-input-button shift-pending-button disabled';
    if (!Utils.isNotDefined(this.props.shiftData) && this.props.shiftData.state != 'accepted') {
      pendingButtonClasses += ' hide';
    }

    let shiftDeets = this.props.shiftData && this.props.shiftData.shift_details
      ? this.props.shiftData.shift_details
      : this.props.shiftData;
    const me = Utils.getCoreUser();
    if (!_.isUndefined(acceptedShift) && !_.isUndefined(exchange) && exchange.user_id == me.id) {
      if (shiftDeets && shiftDeets.id == exchange.accepted_shift_id) {
        shiftDeets = ShiftStore.getAllShiftsByShiftId(this.props.shiftData.shift_id)
      } else {
        this.selectedShifts = [];
      }
    }

    let shiftDate = '';
    if (shiftDeets) {
      const momentObj = moment(shiftDeets.start_time).tz(shiftDeets.time_zone);
      shiftDate = Utils.formatLocaleDate(momentObj);
    }

    return (
      <div className={!this.props.active ? 'hide' : null}>
        <div
          className={
            !this.props.active
              ? 'hide calendar-input exchange-offer'
              : 'calendar-input exchange-offer'
          }
        >
          <span className="calendar-input-bullet exchange">{this.props.t('SidebarExchangeOffer.exchange_post')}</span>
          <div className="shift-detail-content">
            <p className="shift-detail-title">
              {this.hasUserName(userName) && userName.name}
              {this.hasUserName(userName) && <br/>}
              {shiftDeets ? shiftDeets.name : ''}
              <br />
              {shiftDate}
              <br />
              {startTime}
              {' – '}
              {!hideEnd ? endTime : this.props.t('SidebarExchangeOffer.tbd')}
            </p>

            {!Utils.isNotDefined(breaks) && (
              <p className="shift-detail-breaks">
                {this.props.t('SidebarExchangeOffer.breaks')}:&nbsp;
                {breaks}
              </p>
            )}

            <ShiftDetailBlock
              departmentID={shiftDeets ? shiftDeets.department_id : ''}
              locationID={shiftDeets ? shiftDeets.location_id : ''}
              position={shiftDeets ? shiftDeets.position : ''}
              job_site_name={shiftDeets ? shiftDeets.job_site_name : ''}
              job_site_address={shiftDeets ? shiftDeets.job_site_address : ''}
            />
            {!Utils.isNotDefined(shift_notes) && (
              <div className="shift-detail-notes-container">
                <p className="shift-detail-title">{this.props.t('SidebarExchangeOffer.notes').toUpperCase()}</p>
                <p className="shift-detail-notes">{shift_notes}</p>
              </div>
            )}

            {!Utils.isNotDefined(exchange_notes) && (
              <div className="exchange-shift-detail-notes-container">
                <p className="exchange-shift-detail-title">{this.props.t('SidebarExchangeOffer.exchange_notes').toUpperCase()}</p>
                <p className="exchange-shift-detail-notes">{exchange_notes}</p>
              </div>
            )}
          </div>
        </div>
        {this.selectedShifts}
        <div className={buttonClasses} style={{minHeight: 0}}>
          <button className={offerButtonClasses} disabled={disabled} onClick={this.onSubmitBids}>
            {this.props.t('SidebarExchangeOffer.send_offer')}
          </button>
          <button className={cancelButtonClasses} onClick={this.onCancelBids}>
            {this.props.t('SidebarExchangeOffer.cancel_offers')}
          </button>
          <button className={pendingButtonClasses}>{this.props.t('SidebarExchangeOffer.pending_manager_approval')}</button>
        </div>
      </div>
    );
  }
}

export default translate()(SidebarExchangeOffer);
